import { render, staticRenderFns } from "./loanItem.vue?vue&type=template&id=c4188222&scoped=true&"
import script from "./loanItem.vue?vue&type=script&lang=js&"
export * from "./loanItem.vue?vue&type=script&lang=js&"
import style0 from "./loanItem.vue?vue&type=style&index=0&id=c4188222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4188222",
  null
  
)

export default component.exports